"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var react_2 = require("react");

var components_utils_1 = require("@conte-ltd/components-utils");

var toggle_1 = require("@react-stately/toggle");

var switch_1 = require("@react-aria/switch");

var visually_hidden_1 = require("@react-aria/visually-hidden");

var focus_1 = require("@react-aria/focus");

var react_hook_form_1 = require("react-hook-form");

var form_control_1 = require("./form-control");

function _Switch(props, fwRef) {
  var _a = (0, form_control_1.useFormControl)(),
      _b = _a.fieldProps,
      fieldProps = _b === void 0 ? {} : _b,
      inheritIsRequired = _a.isRequired,
      inheritIsReadOnly = _a.isReadOnly,
      inheritIsDisabled = _a.isDisabled,
      setFieldsState = _a.setFieldsState;

  var _c = props.isRequired,
      isRequired = _c === void 0 ? inheritIsRequired : _c,
      _d = props.isReadOnly,
      isReadOnly = _d === void 0 ? inheritIsReadOnly : _d,
      _e = props.isDisabled,
      isDisabled = _e === void 0 ? inheritIsDisabled : _e;
  var control = (0, react_hook_form_1.useFormContext)().control;

  var _f = (0, react_hook_form_1.useController)(__assign(__assign({
    control: control
  }, props), {
    rules: __assign(__assign({}, props.rules), {
      required: isRequired
    })
  })),
      _g = _f.field,
      controlRef = _g.ref,
      name = _g.name,
      value = _g.value,
      controlProps = __rest(_g, ["ref", "name", "value"]),
      fieldState = _f.fieldState;

  var _h = (0, focus_1.useFocusRing)(),
      isFocusVisible = _h.isFocusVisible,
      focusProps = _h.focusProps;

  var newProps = (0, components_utils_1.mergeProps)(props, fieldProps, controlProps, focusProps, {
    name: name,
    value: value,
    isRequired: isRequired,
    isReadOnly: isReadOnly,
    isDisabled: isDisabled,
    isSelected: value
  });
  var ref = (0, react_2.useRef)(null);
  var state = (0, toggle_1.useToggleState)(newProps);
  var inputProps = (0, switch_1.useSwitch)(newProps, state, ref).inputProps;
  (0, components_utils_1.useDeepCompareEffect)(function () {
    setFieldsState === null || setFieldsState === void 0 ? void 0 : setFieldsState(function (prev) {
      var _a;

      return __assign(__assign({}, prev), (_a = {}, _a[name] = __assign({
        value: value,
        isEmpty: (0, components_utils_1.isEmpty)(value, 1),
        isRequired: isRequired || false,
        isReadOnly: isReadOnly || false,
        isDisabled: isDisabled || false
      }, fieldState), _a));
    });
  }, [value, isRequired, isReadOnly, isDisabled, fieldState]);
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        box-sizing: border-box;\n        position: relative;\n        display: inline-block;\n        width: var(--c-switch-width, 2.4em);\n        height: var(--c-switch-height, 1.4em);\n        border-radius: var(--c-switch-rounded, 9999px);\n        background: var(--c-switch-bg, gray);\n        transition: var(--c-switch-transition, all 0.1s ease-in);\n\n        & > [data-switch-knob] {\n          position: absolute;\n          top: var(--c-switch-spacing, 0.2em);\n          left: var(--c-switch-spacing, 0.2em);\n          display: inline-block;\n          width: var(--c-switch-knob-size, 1em);\n          height: var(--c-switch-knob-size, 1em);\n          border-radius: 9999px;\n          background-color: white;\n          transition: var(--c-switch-transition, all 0.1s ease-in);\n        }\n\n        &[data-active] {\n          background: var(--c-switch-active-bg, var(--c-color-primary, black));\n\n          & > [data-switch-knob] {\n            left: calc(\n              var(--c-switch-width, 2.4em) - var(--c-switch-knob-size, 1em) -\n                var(--c-switch-spacing, 0.2em)\n            );\n          }\n        }\n      "], ["\n        box-sizing: border-box;\n        position: relative;\n        display: inline-block;\n        width: var(--c-switch-width, 2.4em);\n        height: var(--c-switch-height, 1.4em);\n        border-radius: var(--c-switch-rounded, 9999px);\n        background: var(--c-switch-bg, gray);\n        transition: var(--c-switch-transition, all 0.1s ease-in);\n\n        & > [data-switch-knob] {\n          position: absolute;\n          top: var(--c-switch-spacing, 0.2em);\n          left: var(--c-switch-spacing, 0.2em);\n          display: inline-block;\n          width: var(--c-switch-knob-size, 1em);\n          height: var(--c-switch-knob-size, 1em);\n          border-radius: 9999px;\n          background-color: white;\n          transition: var(--c-switch-transition, all 0.1s ease-in);\n        }\n\n        &[data-active] {\n          background: var(--c-switch-active-bg, var(--c-color-primary, black));\n\n          & > [data-switch-knob] {\n            left: calc(\n              var(--c-switch-width, 2.4em) - var(--c-switch-knob-size, 1em) -\n                var(--c-switch-spacing, 0.2em)\n            );\n          }\n        }\n      "]))),
    "data-required": isRequired || undefined,
    "data-readonly": isReadOnly || undefined,
    "data-disabled": isDisabled || undefined,
    "data-invalid": fieldState.invalid || undefined,
    "data-active": state.isSelected || undefined,
    "data-focus-visible": isFocusVisible || undefined
  }, (0, components_utils_1.styleProps)(props), {
    children: [(0, jsx_runtime_1.jsx)(visually_hidden_1.VisuallyHidden, {
      children: (0, jsx_runtime_1.jsx)("input", __assign({
        ref: (0, components_utils_1.mergeRefs)([ref, fwRef])
      }, inputProps), void 0)
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      "aria-hidden": true,
      "data-switch-knob": true
    }, void 0)]
  }), void 0);
}

exports.Switch = (0, react_2.forwardRef)(_Switch);
var templateObject_1;